import { lazy, Suspense, type ComponentProps, type FC } from 'react';
import cn from 'classnames';
import dibsCss from 'dibs-css';

const LazySinglePersonalizedCollectionBanner = lazy(
    () =>
        import(
            /* webpackChunkName: "SinglePersonalizedCollectionBanner" */ './SinglePersonalizedCollectionBanner.tsx'
        )
);

export const SinglePersonalizedCollectionBannerLoading: FC<{ isMobile: boolean }> = ({
    isMobile,
}) => {
    const shimmerTilesCount = isMobile ? 2 : 5;
    return (
        <div
            style={{ maxHeight: isMobile ? 'auto' : '475px' }}
            className={cn(dibsCss.flex, dibsCss.flexCol, dibsCss.mbLarger, dibsCss.hAuto)}
        >
            <span
                className={cn(
                    dibsCss.myMedium,
                    dibsCss.pyMedium,
                    dibsCss.hLarge,
                    dibsCss.w300px,
                    dibsCss.loadingShimmer
                )}
            />
            <div className={cn(dibsCss.flex, dibsCss.justifyBetween, dibsCss.gapSmall)}>
                {Array.from({ length: shimmerTilesCount }).map((_, index) => (
                    <div
                        style={{ height: isMobile ? '290px' : '345px' }}
                        key={index}
                        className={cn(dibsCss.wFull, dibsCss.hAuto, dibsCss.loadingShimmer)}
                    />
                ))}
            </div>
            {isMobile && (
                <div style={{ height: '184px' }} className={(dibsCss.myLarge, dibsCss.pyLarge)}>
                    <div className={cn(dibsCss.flex, dibsCss.gapSmall)}>
                        <div
                            style={{ height: '72px', width: '72px' }}
                            className={cn(dibsCss.loadingShimmer, dibsCss.roundedFull)}
                        />
                        <div>
                            <div
                                style={{ height: '40px', width: '250px' }}
                                className={cn(
                                    dibsCss.loadingShimmer,
                                    dibsCss.wFull,
                                    dibsCss.mbXsmall
                                )}
                            />
                            <div
                                style={{ height: '20px', width: '120px' }}
                                className={dibsCss.loadingShimmer}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const SuspendedSinglePersonalizedCollectionBanner: FC<
    ComponentProps<typeof LazySinglePersonalizedCollectionBanner>
> = props => {
    return (
        <Suspense
            fallback={<SinglePersonalizedCollectionBannerLoading isMobile={props.isMobile} />}
        >
            <LazySinglePersonalizedCollectionBanner {...props} />
        </Suspense>
    );
};

export default SuspendedSinglePersonalizedCollectionBanner;
